import useSWR from "swr";

import { getJSON } from "@/utils/swr";

const API_URL = `${import.meta.env.VITE_API_HOST}/api/trustpilot_business_unit`;

export interface TrustpilotBusinessUnitResponse {
  id: string;
  country: string;
  displayName: string;
  websiteUrl: string;
  status: string;
  trustScore: number;
  stars: number;
  numberOfReviews: number;
  profileUrl: string;
  evaluateUrl: string;
  evaluateEmbedUrl: string;
}

const getTrustpilotBusinessUnit = getJSON<{
  data: TrustpilotBusinessUnitResponse;
  errors: string[];
}>("Failed to load Trustpilot Business Unit");

export const useTrustpilotBusinessUnitQuery = () => {
  const { data, error, isLoading } = useSWR(API_URL, getTrustpilotBusinessUnit);

  return {
    businessUnit: data?.data,
    businessUnitError: error || !!data?.errors?.[0],
    isLoadingBusinessUnit: isLoading,
  };
};
